import request from '@/plugin/axios'

/**
 * 根据条件查询结算记录
 * @param params
 * @returns {AxiosPromise}
 */
export function findRoomBillingStatementPage (params) { // PresetRecord
  return request({
    url: '/v1/electricity/roomBillingStatement/findRoomBillingStatementPage',
    method: 'get',
    params
  })
}

/**
 * 根据条件查询结算记录
 * @param params
 * @returns {AxiosPromise}
 */
export function findRoomBillingDetailsPage (params) { // PresetRecord
  return request({
    url: '/v1/electricity/roomBillingStatement/findRoomBillingDetailsPage',
    method: 'get',
    params
  })
}

/**
 * 根据条件查询结算记录
 * @param params
 * @returns {AxiosPromise}
 */
export function findInsufficientBalanceVoPage (params) { // PresetRecord
  return request({
    url: '/v1/electricity/roomBillingStatement/findInsufficientBalanceVoPage',
    method: 'get',
    params
  })
}

/**
 * 查询当天抄表失败记录
 * @param params
 * @returns {AxiosPromise}
 */
export function findReadTheListOfFailuresVo (params) { // PresetRecord
  return request({
    url: '/v1/electricity/roomBillingStatement/findReadTheListOfFailuresVo',
    method: 'get',
    params
  })
}
